import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const AreaSelect = () => {
  const map = useMap();

  useEffect(() => {
    if (!map.selectArea) return;

    // enable select area
    map.selectArea.enable();

    // save rectangle in memory to delete it later
    let rectangle = null;

    map.on("areaselected", (e) => {
      rectangle = L.rectangle(e.bounds, { color: "blue", weight: 1 }).addTo(map);
      // zoom to fit to rectangle
      map.fitBounds(rectangle.getBounds());
      map.removeLayer(rectangle);
    });

    map.selectArea.setValidate((layerPoint) => {
      return bounds.contains(this._map.layerPointToLatLng(layerPoint));
    });

    map.selectArea.setValidate();
  }, []);

  return null;
};

export default AreaSelect;
